import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../features/user/userSlice';
import distributorReducer from '../features/distributor/DistributorSlice';
import dashboardReducer from '../features/dashboard/DashboardSlice';
import principalReducer from '../features/principal/PrincipalSlice';
import programReducer from '../features/program/ProgramSlice';
import distributorReconReducer from '../features/distributor/DistributorReconSlice';
import rootReducer from './rootReducer';
import tenantReducer from '../features/outlet/TenantSlice';
import utrReducer from '../features/outlet/UtrSlice';
import paymentGatewayReducer from '../features/payment/PaymentGatewaySlice';
import voucherReducer from '../features/voucher/VoucherSlice';
import purposeCodeReducer from '../features/purposeCode/PurposeCodeSlice';
import misReducer from '../features/mis/MISSlice';
import rbacReducer from '../features/rbac/RBACSlice';
import reconReducer from '../features/recon/ReconSlice';
import billingMISReducer from '../features/billing/BillingMISSlice';
import processorOnboardingReducer from '../features/principal/ProcessorOnboardingSlice';
import lobConfigReducer from '../features/lobConfig/LobConfigSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    distributor: distributorReducer,
    dashboard: dashboardReducer,
    root: rootReducer,
    principal: principalReducer,
    program: programReducer,
    distributorRecon: distributorReconReducer,
    tenant: tenantReducer,
    utr: utrReducer,
    paymentGateway: paymentGatewayReducer,
    voucher: voucherReducer,
    purposeCode: purposeCodeReducer,
    mis: misReducer,
    rbac: rbacReducer,
    recon: reconReducer,
    billingMIS: billingMISReducer,
    processorOnboarding: processorOnboardingReducer,
    lobConfig: lobConfigReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export default store;
